import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@core/guard';
import { LayoutDefaultComponent } from '@layout/layout.component';
import { LayoutPassportComponent } from '@layout/passport';
import { AlipayBankAccountIndexComponent } from './passport/alipay/alipay.component';

const routes: Routes = [
  {
    path: 'passport',
    component: LayoutPassportComponent,
    loadChildren: () => import('./passport/passport.module').then(m => m.PassportModule)
  },
  { path: 'exception', loadChildren: () => import('./exception/exception.module').then(m => m.ExceptionModule) },
  {
    path: '',
    component: LayoutDefaultComponent,
    canLoad: [AuthGuard],
    loadChildren: () => import('./routes/routes.module').then(m => m.RoutesModule)
  }, //
  {
    path: 'alipayBankAccount',
    component: AlipayBankAccountIndexComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, scrollPositionRestoration: 'top' })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
